var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardIconCopyImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-icon-copy-image",
    transform: "translate(0.286 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(1.114 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M754.645,105.451l2.106,2.106a2.1,2.1,0,0,1,.617,1.489v14.32a2.106,2.106,0,0,1-2.106,2.106H742.627a2.106,2.106,0,0,1-2.106-2.106V106.94a2.106,2.106,0,0,1,2.106-2.106h10.529A2.1,2.1,0,0,1,754.645,105.451Z",
    transform: "translate(-740.521 -104.834)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 8.423,
    transform: "translate(4.212 6.318)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x2: 8.423,
    transform: "translate(4.212 10.529)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 4.212,
    transform: "translate(4.212 14.741)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M834.542,214.524v3.08a1.888,1.888,0,0,0,1.888,1.888h11.493a3.466,3.466,0,0,0,3.466-3.466V200.742a1.888,1.888,0,0,0-1.888-1.888h-3.062",
    transform: "translate(-829.592 -193.904)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5657",
    "data-name": "Rectangle 5657",
    width: 25,
    height: 28,
    transform: "translate(-0.286 0)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconCopyImage);
export default __webpack_public_path__ + "static/media/card-icon-copy-image.a2144f6a993f3bda5d0b33bc519ee341.svg";
export { ForwardRef as ReactComponent };